import React, { useEffect, useState } from 'react'
import { ClassValue } from 'classnames/types'
import { SearchIcon } from '../../../icons/icons'
import { Icon } from '@blueprintjs/core'
import { Tooltip } from '../../../components/ui/tooltip'
interface SearchProps {
    width?: number
    fluid?: boolean
    placeholder?: string
    disabled?: boolean
    onSearch?: any
    value?: string
    className?: ClassValue
    loading?: boolean
    style?: object
    onChange?: any
    showSubmitIcon?: boolean
    showClearIcon?: boolean
    iconTooltipContent?: React.ReactNode
}

export const Search = ({
    width,
    fluid = false,
    placeholder,
    disabled,
    onSearch,
    value,
    className,
    loading,
    style,
    onChange,
    showSubmitIcon = true,
    showClearIcon = true,
    iconTooltipContent,
}: SearchProps) => {
    const [query, setQuery] = useState(value || '')
    useEffect(() => {
        setQuery(value || '')
    }, [value])

    const keyPressed = (e: any) => {
        if (e.key === 'Enter') {
            search()
        }
    }

    const search = () => {
        if (onSearch) {
            onSearch(query)
        } else {
            console.warn('No onSearch method set in Search component')
        }
    }

    const clearSearchInput = () => {
        setQuery('')
        onSearch('')
    }

    const _onChange = (e: any) => {
        if (onChange != null) {
            onChange(e)
        }
        if (!loading) {
            setQuery(e.target.value)
        }
    }

    return (
        <div
            className={'bp4-input-group ' + className}
            style={{
                ...style,
                maxWidth: fluid ? undefined : width ? width : undefined,
                width: fluid ? '100%' : undefined,
            }}
        >
            <span className="bp4-icon">
                <Tooltip
                    disabled={!iconTooltipContent}
                    content={iconTooltipContent}
                    openOnTargetFocus={false}
                >
                    <div className="mt-0.5 ml-px cursor-help">
                        <SearchIcon />
                    </div>
                </Tooltip>
            </span>
            <input
                value={query}
                onChange={_onChange}
                disabled={disabled}
                type="text"
                className="bp4-input rounded-lg text-mjDark-1400 placeholder-mjDark-600"
                style={{
                    height: 33,
                    width: fluid ? '100%' : 290,
                }}
                onKeyPress={keyPressed}
                placeholder={placeholder ? placeholder : 'Search'}
            />

            {showClearIcon && (
                <Icon
                    className="hover:cursor-pointer pt-0.5"
                    icon="key-backspace"
                    color="#CDD6DF"
                    onClick={() => clearSearchInput()}
                />
            )}
        </div>
    )
}
